import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Users, Target, TrendingUp } from 'lucide-react';

export function SessionMetrics() {
  const metrics = [
    {
      label: 'Total Sessions',
      value: '186',
      change: '+12',
      trend: 'up',
      period: 'This month',
      icon: <Clock className="w-4 h-4" />
    },
    {
      label: 'Avg. Attendance',
      value: '92%',
      change: '+5%',
      trend: 'up',
      period: 'vs last month',
      icon: <Users className="w-4 h-4" />
    },
    {
      label: 'Goal Completion',
      value: '88%',
      change: '+3%',
      trend: 'up',
      period: 'This month',
      icon: <Target className="w-4 h-4" />
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <Clock className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Session Analytics</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg"
          >
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              {metric.icon}
              <span>{metric.label}</span>
            </div>
            <div className="text-2xl font-bold">{metric.value}</div>
            <div className="flex items-center justify-between mt-2">
              <div className="text-xs text-muted-foreground">
                {metric.period}
              </div>
              <div className="flex items-center gap-1 text-xs text-success">
                <TrendingUp className="w-3 h-3" />
                <span>{metric.change}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Session Distribution */}
      <div className="mt-6 space-y-4">
        <h3 className="text-sm font-medium">Session Distribution</h3>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">1-on-1 Training</span>
            <span>65%</span>
          </div>
          <div className="h-2 bg-muted rounded-full overflow-hidden">
            <div className="h-full bg-primary" style={{ width: '65%' }} />
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Group Classes</span>
            <span>25%</span>
          </div>
          <div className="h-2 bg-muted rounded-full overflow-hidden">
            <div className="h-full bg-primary" style={{ width: '25%' }} />
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Online Coaching</span>
            <span>10%</span>
          </div>
          <div className="h-2 bg-muted rounded-full overflow-hidden">
            <div className="h-full bg-primary" style={{ width: '10%' }} />
          </div>
        </div>
      </div>
    </div>
  );
}